import { FormToggleComponent } from "./toggle/toggle.component";
import { FormSegmentComponent } from "./segment/segment.component";
import { FormTextComponent } from "./text/text.component";
import { FormNumberComponent } from "./number/number.component";
import { FormMultiPictureComponent } from "./multi-picture/multi-picture.component";
import { FormDimensionComponent } from "./dimension/dimension.component";
import { FormSelectComponent } from "./select/select.component";

export const CUSTOM_COMPONENT_DIRECTIVES = [
	FormToggleComponent,
	FormSegmentComponent,
	FormTextComponent,
	FormNumberComponent,
	FormMultiPictureComponent,
	FormDimensionComponent,
	FormSelectComponent,
];

export function customComponentFactory() {
	return new Map([
		["toggle", FormToggleComponent],
		["segment", FormSegmentComponent],
		["number", FormNumberComponent],
		["text", FormTextComponent],
		["multi-picture", FormMultiPictureComponent],
		["dimension", FormDimensionComponent],
		["select", FormSelectComponent],
	]);
}
